import httpClient from '../utils/httpClient';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

const postJson = async (path: string, body: Record<string, unknown> = {}) => {
  const { json } = await httpClient(`${getApiBaseUrl()}/${path}`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return json;
};

const putJson = async (path: string, body: Record<string, unknown>) => {
  const { json } = await httpClient(`${getApiBaseUrl()}/${path}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
  return json;
};

const getJson = async (path: string) => {
  const { json } = await httpClient(`${getApiBaseUrl()}/${path}`);
  return json;
};

export const getLeadEnrichmentPhase = async () =>
  getJson('leadcompanies/enrichment/phase') as Promise<{
    phase: string;
    label: string;
    description: string;
    allowed_buckets: string[];
    next_phase: string | null;
    env_var: string;
  }>;

export const queueLeadEnrichment = async (companyIds: number[], force = false) =>
  postJson('leadcompanies/queue-enrichment', { company_ids: companyIds, force });

export const queueSingleLeadEnrichment = async (companyId: number, force = false) =>
  postJson(`leadcompanies/${companyId}/enrichment/queue`, { force });

export const queueLeadEnrichmentPhase = async () =>
  postJson('leadcompanies/enrichment/queue-phase');

export const processLeadEnrichmentBatch = async (limit = 25) =>
  postJson('leadenrichmentjobs/process', { limit });

export const retryFailedLeadJobs = async () => postJson('leadenrichmentjobs/retry');

export const syncLeadCredcoLinkage = async () => postJson('leadcompanies/credco-linkage/sync');

export const updateLeadEnrichment = async (companyId: number, payload: Record<string, unknown>) =>
  putJson(`leadcompanies/${companyId}/enrichment`, payload);

export const addLeadActivity = async (
  companyId: number,
  payload: { activity_type?: string; note?: string; assigned_to?: string }
) => postJson(`leadcompanies/${companyId}/activities`, payload);

export type LeadIntelligence = {
  commercial: {
    buyer_observed_value: number;
    seller_observed_value: number;
    buyer_share_pct: number;
    seller_share_pct: number;
    buyer_invoice_rows: number;
    seller_invoice_rows: number;
    seller_customer_count: number;
    observed_supplier_count: number;
  };
  online_depth: {
    score: number;
    rationale_items: string[];
    signals: Array<{ key: string; label: string; active: boolean }>;
  };
  credco: {
    customer?: Record<string, unknown> | null;
    order_trend?: Array<{ period: string; gmv_inr: number; order_count: number }>;
    inquiry_trend?: Array<{ period: string; inquiry_count: number }>;
    totals_12m?: { orders: number; gmv_inr: number } | null;
    error?: string;
  } | null;
  gst_snapshot?: Record<string, unknown> | null;
  enrichment_jobs_summary?: {
    total: number;
    by_status: Record<string, number>;
    latest: Array<Record<string, unknown>>;
  };
};

export const getLeadIntelligence = async (companyId: number) =>
  getJson(`leadcompanies/${companyId}/intelligence`) as Promise<LeadIntelligence>;
